import styled from 'styled-components';

import { media } from '../../../styles/breakpoints';

type StatusProps = {
  $color: string;
};

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 4px;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 2px;
  }
`;

export const FileCard = styled.div<StatusProps>`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #fafafa;
  border-radius: 10px;
  border-left: 4px solid ${({ $color }) => $color};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    transform: translateX(2px);
  }

  &:active {
    background: #f0f0f0;
  }

  ${media.md} {
    padding: 12px 14px;
  }
`;

export const FileIcon = styled.div<StatusProps>`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${({ $color }) => `color-mix(in srgb, ${$color} 12%, transparent)`};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    color: ${({ $color }) => $color};
  }

  ${media.md} {
    width: 36px;
    height: 36px;
    margin-right: 12px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const FileInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileDescription = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${media.md} {
    font-size: 13px;
  }
`;

export const FileDueDate = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 2px;
`;

export const FileAction = styled.div<StatusProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${({ $color }) => $color};
  color: #fff;
  margin-left: 12px;
  flex-shrink: 0;
  transition: all 0.2s;

  svg {
    width: 18px;
    height: 18px;
  }

  ${FileCard}:hover & {
    transform: scale(1.05);
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 32px 16px;
  color: rgba(0, 0, 0, 0.45);

  svg {
    width: 48px;
    height: 48px;
    margin-bottom: 12px;
    opacity: 0.5;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
`;

export const ModalHeader = styled.div<StatusProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;

  .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: ${({ $color }) => `color-mix(in srgb, ${$color} 12%, transparent)`};
    color: ${({ $color }) => $color};
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
  }

  .file-count {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.45);
  }
`;
